


















import { Vue, Component, Prop } from 'vue-property-decorator';
import Comment from '@/components/business/comments/Comment.vue';
import Swiper from 'swiper';
@Component({
  components: { Comment },
})
export default class CommentSwiper extends Vue {
  @Prop() commentsData!: object;
  mounted() {
    new Swiper('#comment-swiper-mobile', {
      slidesPerView: 'auto',
      // 无限循环
      loop: true,
      // 自动滚动
      autoplay: {
        // 自动滚动时间间隔
        delay: 3000,
        // 任意操作后停止自动播放
        disableOnInteraction: true,
      },
      direction: 'horizontal',
    });
  }
}
